class BlogEmailClick {
  constructor(targetSelector) {
    this.targetSelector = targetSelector
    this.initBlogEmailClick()
  }

  initBlogEmailClick() {}
}
export { BlogEmailClick }
